/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
import { SessionSpanProcessor } from './SessionSpanProcessor';
import { SessionLogRecordProcessor } from './SessionLogRecordProcessor';
import { SessionManager } from './SessionManager';
import { DefaultIdGenerator } from './DefaultIdGenerator';
import { LocalStorageSessionStore } from './LocalStorageSessionStore';
export function createSessionSpanProcessor(sessionProvider) {
    return new SessionSpanProcessor(sessionProvider);
}
export function createSessionLogRecordProcessor(sessionProvider) {
    return new SessionLogRecordProcessor(sessionProvider);
}
export function createSessionManager(config) {
    const manager = new SessionManager(config);
    return manager;
}
export function createDefaultSessionIdGenerator() {
    return new DefaultIdGenerator();
}
export function createLocalStorageSessionStore() {
    return new LocalStorageSessionStore();
}
//# sourceMappingURL=utils.js.map